import { Box } from "@chakra-ui/react";
import { FC, PropsWithChildren } from "react";

type Props = {
  isActive?: boolean;
  isDisabled?: boolean;
  onClick: VoidFunction;
};

const TabLink: FC<PropsWithChildren<Props>> = ({
  isActive,
  isDisabled,
  children,
  onClick,
  ...props
}) => (
  <Box
    asChild
    display="block"
    borderColor="currentColor"
    fontWeight="bold"
    fontSize="md"
    py={2}
    px={4}
    borderRadius="20px"
    color={isActive ? "white" : "currentColor"}
    bg={isActive ? "link" : undefined}
    transition="0.2s all ease-in-out"
    _hover={{ bg: isActive ? undefined : "#edf2f7" }}
    _disabled={{ cursor: "not-allowed", opacity: 0.5 }}
  >
    <button {...props} disabled={isDisabled} onClick={onClick}>
      {children}
    </button>
  </Box>
);

export default TabLink;
